import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./FileManagerModal.css";
import { Button, Modal } from "react-bootstrap";
import SearchIcon from "@mui/icons-material/Search";
// import { getStatusWithKey } from '@/shared/utility';
import {
  PrimaryBtnOutlineAction,
  SecondaryBtnOutlineAction,
  CancelBtnOutlineAction,
  FormGroup,
  FormLabel,
} from "../../../styles/Common";

import FileUploaderBtn from "../FileUploaderBtn/FileUploaderBtn"; 
import Checkbox from "@mui/material/Checkbox";
import { getNotyfObject } from '../../../shared/utility';

import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CancelIcon from "@mui/icons-material/Cancel";
import GetAppIcon from "@mui/icons-material/GetApp";
import Axios from "../../../axios-proas"
import exempleFile from '../../../assets/exempleFichierUsersImportEnMasse.xlsx';
import { NoContent, SpinnerContainer, Table, TBody } from '../.././../styles/Table.styled';
import { Spinner } from 'react-bootstrap';

//import { ModalPopup } from "@/components/generic/modal";

function FileManagerModal(props) {

    const { show, modalClosed, dataType, handleReset } = props;
  //dataType nous permet de savoir est ce que c'est limport des users ou bailleurs
    const [fields, setFields] = useState(null);
    const [modeMaj,setModeMaj]=useState(0)
    const [bailleurs, setBailleurs] = useState(null);
    const notyf = getNotyfObject();
    const [loading, setLoading]=useState(false)
    useEffect(() => { getListBailleur() }, []);

    let tSpinner = (
        <SpinnerContainer>
            <Spinner animation="border" variant="primary" />
        </SpinnerContainer>)
    
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0] && e.target.name === "file") {
      let tmpDoc = {
        formData: e?.target.files[0],
        fileName: e?.target.files[0].name,
        fileType: e?.target.files[0].type,
      };
      setFields(tmpDoc);
    }
  };
    const getListBailleur = () => {
        Axios.get(import.meta.env.VITE_PREFIX_SERVER_API + `Bailleurs`, {
            params: null,
        }).then(res => {
            let temp = res.data.map((item, index) => {
                return { Id: item.id, RaisonSociale: item.raisonSociale, LibelleCourt: item.libelleCourt, Logo: item.logo, AdresseMail: item.AdresseMail }

            })
            setBailleurs(temp)
        })
    }
    const handleFileSend = (e) => { 
        if (!fields || !fields.formData) {
            notyf.warn("Aucun fichier sélectionné !")
            console.warn("No file selected!");
            return; // Stop the function if no file
        }
        setLoading(true)
        if (fields) {         
            // Creating a FormData object to send the file
            const formData = new FormData();
            formData.append('file', fields.formData);
            formData.append('fileName', fields.fileName);
            formData.append('fileType', fields.fileType);
            formData.append('bailleurs', JSON.stringify(bailleurs));
            formData.append('modeMaj', JSON.stringify(modeMaj));
            // Sending the file to the backend
           

            Axios.post(import.meta.env.VITE_PREFIX_SERVER_IDENTITY +'CreateUsers/addUsersImport', 
              formData,
            )
                .then(response => {
                    console.log('Success:', response.data.createdUsers);
                    setLoading(false)
                    if (modeMaj==0)
                        notyf.success(`${response.data.createdUsers} utilisateurs ajoutés`)
                    else
                        notyf.success(`${response.data.createdUsers} utilisateurs modifiés`)
                    handleReset()
                    modalClosed();
                }
                  
             )
            .catch((error) => {
                setLoading(false)
                notyf.error( "Une erreur s'est produite");

                console.error('Error:', error);
            });
        }
    };
        const handleDownload = () => {
            const link = document.createElement('a');
            link.href = exempleFile;
            link.download = 'Exemple.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };
    return (
        <div style={{ width: "100%"  }}>
          <Modal  show={show} onHide={modalClosed} modalTitle={" Gestion & mise à jour du référentiel"} className="Repository">
     
           <div style={{ borderBottom: "4px solid #D9E1E7", margin: "25px" }} className="ADMCreationModal__body">
                  <p style={{ color: "#505050", padding: "4px 0px 7px 9px" }}>
                        Ce mode de mise à jour est uniquement compatible avec le fichier de référentiel Excel standard.
                        Vous pouvez télécharger un modèle vierge en utilisant le lien suivant :{" "}
                        <GetAppIcon onClick={handleDownload} style={{ color: "#2174B9 " }} />{" "}
                        <span style={{ color: "#2174B9 ", cursor: "pointer" }} onClick={handleDownload}>fichier Excel standard</span>
                    </p>

                    <div style={{ marginTop: "25px" }}>
                        <FormLabel>{"Mode de mise à jour"}</FormLabel>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <Checkbox
                                checkedIcon={<CheckCircleOutlinedIcon />} // Icon to show when the checkbox is checked
                                icon={<RadioButtonUncheckedIcon />} // Icon to show when the checkbox is not checked
                                checked={modeMaj==0} // Set this to true to show the checked icon, or false for the unchecked icon
                                onChange={(e) => setModeMaj(0)} // Handle the checkbox state change
                            />
                            <span style={{ color: "#505050" }}>{"Création de nouveaux comptes"}</span>
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <Checkbox
                                checkedIcon={<CheckCircleOutlinedIcon />} // Icon to show when the checkbox is checked
                                icon={<RadioButtonUncheckedIcon />} // Icon to show when the checkbox is not checked
                                checked={modeMaj==1} // Set this to true to show the checked icon, or false for the unchecked icon
                                onChange={(e) => setModeMaj(1)} // Handle the checkbox state change
                            />
                            <span style={{ color: "#505050" }}>
                                {"Mise à jour des comptes existants"}
                            </span>
                        </div>
                    </div>
                    {loading && tSpinner}

                    <div style={{ marginBottom:"15px" }}>
                        <FormGroup>
                          <FileUploaderBtn
                            border={true}
                            label={true}
                            btnLabel="Charger le fichier "
                            handleChange={handleFileChange}
                            name="file"
                          />
                          <FormLabel color="#505050">
                            {fields?.fileName}{" "}
                            {fields?.fileName ? (
                              <CancelIcon style={{ color: "#EE5A5A" }} />
                            ) : null}
                          </FormLabel>
                        </FormGroup>
                     </div>

        

        </div>
        <div style={{ display:"flex",justifyContent: "center",margin: "10px" }}>
                    <PrimaryBtnOutlineAction
                        style={{ backgroundColor: "#00B050" }}
                        variant="secondary"
                        onClick={handleFileSend}
            // disabled={statusValue === "LITIGATION" && !comment}
          >
            Confirmer
          </PrimaryBtnOutlineAction>
          <CancelBtnOutlineAction variant="secondary" onClick={modalClosed}>
            Annuler
          </CancelBtnOutlineAction>
        </div>
      </Modal>
    </div>
  );
}

export default FileManagerModal;
